// In-memory TTL cache for the China catalog proxy. MercuryX answers slowly
// and the catalog doesn't change every second, so /categories and /products
// are cached client-side for ~5 min (per the API spec, section 8.4).
// Cart and orders are intentionally NOT cached here.

export const CHINA_CACHE_TTL = 5 * 60 * 1000;

// Product detail changes less often than the listing surface, but stale
// stock/price is worse here than on the grid — keep a short TTL so a quick
// back/forward still hits cache without serving outdated detail for long.
export const CHINA_PRODUCT_CACHE_TTL = 60 * 1000;

const store = new Map();

export function cachedGet(key, ttlMs, fetcher) {
    const hit = store.get(key);
    if (hit && hit.expiresAt > Date.now()) {
        return Promise.resolve(hit.value);
    }
    return Promise.resolve(fetcher()).then(value => {
        store.set(key, { value, expiresAt: Date.now() + (ttlMs || CHINA_CACHE_TTL) });
        return value;
    });
}

export function invalidateChinaCache(prefix) {
    if (!prefix) {
        store.clear();
        return;
    }
    for (const key of store.keys()) {
        if (key.startsWith(prefix)) store.delete(key);
    }
}